/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/* eslint-disable react/no-multi-comp */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

class Grid extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        caption: PropTypes.string,
    };

    render() {
        const { children, className, caption, ...otherProps } = this.props;

        return (
            <div
                data-component="Grid"
                role="grid"
                aria-label={caption}
                className={cx('rec-grid-grid', className)}
                {...otherProps}
            >
                {children}
            </div>
        );
    }
}

class Row extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    };

    render() {
        const { children, className, ...otherProps } = this.props;

        return (
            <div
                data-testid="Row"
                data-component="Row"
                role="row"
                className={cx('rec-grid-row', className)}
                {...otherProps}
            >
                {children}
            </div>
        );
    }
}

class GridHeaderCell extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    };

    render() {
        const { children, className, ...otherProps } = this.props;

        return (
            <div
                data-testid="grid-header-cell"
                data-component="GridHeaderCell"
                role="columnheader"
                className={cx('rec-grid-row', className)}
                {...otherProps}
            >
                {children}
            </div>
        );
    }
}

class GridCell extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    };

    render() {
        const { children, className, ...otherProps } = this.props;

        return (
            <div
                data-testid="grid-cell"
                data-component="GridCell"
                role="gridcell"
                className={cx('rec-grid-grid-cell', className)}
                {...otherProps}
            >
                {children}
            </div>
        );
    }
}

export { Grid, Row, GridHeaderCell, GridCell };
